import React from "react";
import { ReactNode } from "react";
import { experimentalFeatureCheck } from "./experimentalFeatureHelper";

type ExperimentalFeatureProps = {
  children: ReactNode;
  experimentalModuleName: string;
  experimentalFeatures: { [key: string]: any }[];
  experimentalFeatureVisibleName?: string;
  experimentalFeatureHiddenName?: string;
};

const EXPERIMENTALFEATURETOGGLETYPE = 3;

export const ExperimentalFeature: React.FC<ExperimentalFeatureProps> = ({
  children,
  experimentalModuleName,
  experimentalFeatureVisibleName,
  experimentalFeatureHiddenName,
  experimentalFeatures,
}) => {
  const featureToggleVisible = experimentalFeatureVisibleName
    ? experimentalFeatureCheck(
        experimentalModuleName,
        experimentalFeatures,
        EXPERIMENTALFEATURETOGGLETYPE,
        experimentalFeatureVisibleName
      )
    : true;

  const featureToggleHidden = experimentalFeatureHiddenName
    ? experimentalFeatureCheck(
        experimentalModuleName,
        experimentalFeatures,
        EXPERIMENTALFEATURETOGGLETYPE,
        experimentalFeatureHiddenName
      )
    : false;

  return <>{featureToggleVisible && !featureToggleHidden ? children : null}</>;
};
